import {
    IonPage, IonContent, IonAlert
} from '@ionic/react';
import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import MFooter from "../../components/MFooter";
import "./MPay.css"
import {Helmet} from "react-helmet";
import cookieUtil from "../../utils/cookieUtil";
import {GetItemList} from "./commonPay";
import {GetAccountInfo, jumpLogin} from "../../utils/common";
import {rechargeCreate, rechargePay} from "./Service";
import {key} from "ionicons/icons";


class MPay extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isH5: true,
            currpage: 1,
            showTipMsg: null,
            isYesOne: true,
            isYesTwo: true,
            userInfo: {
                nickName: '',
                userGameId: '',
                goldEgg: 0,
                score: 0,
                insureScore: 0,
                headImg: ''
            },
            itemList: [],
            chooseCommodityId: null,
            rechargePrice: 0,
            chooseSubtype: null,
            payType: null,
            tradeType: null,
            token: null,
            payBankId: null,
            payOrderId: null,
            paySource: 0,
            payName: null,
            vipDay: 0,
            payVip: null,
        }
    }

    componentDidMount() {
        if (cookieUtil.has("access_token")) {
            let userInfo = this.state.userInfo;
            if (cookieUtil.has("userInfo")) {
                userInfo = JSON.parse(cookieUtil.get("userInfo"));
                //console.log(userInfo)
                this.setState({userInfo})
            } else {
                GetAccountInfo(this.isGetInfo, true).then();
            }

            this.setState({token: cookieUtil.get("access_token")})

            GetItemList(1, '10014,10015', this.getItem).then();
        }else{
            console.log("1");
        }
    }
    isGetInfo = (ret, isLogin) => {
        console.log(ret);
        let url = window.location.href;
        if (ret.code === '10000') {
            let userInfo = ret.data;
            cookieUtil.put("userInfo", JSON.stringify(userInfo));
            this.setState(userInfo);
        } else {
            cookieUtil.remove("access_token");
            cookieUtil.remove("userInfo");
            if (isLogin) {
                jumpLogin(url);
            } else {
                window.location.href = url;
            }
        }
    }
    getItem = (data) => {
        if (data != null && (typeof data.totalCount !== undefined && data.totalCount > 0)) {
            this.setState({itemList: data.list})
        }
    }
    /**
     * 选中的商品
     */
    chooseItemBox = (commodityId, subtype, price) => {
        this.setState({
            chooseCommodityId: commodityId,
            chooseSubtype: subtype,
            rechargePrice: price,
        })
    }
    /**
     * 下一步跳转
     */
    jumpNext = (par) => {
        const {
            isH5,
            token,
            isYesOne,
            isYesTwo,
            chooseCommodityId,
            rechargePrice,
            chooseSubtype,
            payType,
            tradeType,
            payBankId,
            userInfo,
            payOrderId
        } = this.state;

        if (chooseCommodityId === null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请选择要充值的商品'
            })
            return;
        }
        if (rechargePrice === 0) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请先选择要充值的金额！'
            })
            return;
        }
        if (chooseSubtype == null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请先选择要充值的类型！'
            })
            return;
        }
        if (par !== 2 && (!isYesOne || !isYesTwo)) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请确保已阅读并接受《关于充值的特别提示和约定》和购买须知'
            })
            return;
        }
        if (par !== 2 && payType !== 17 && payType !== 61) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请选择充值方式'
            })
            return;
        }
        if (par === 2) {
            this.setState({currpage: par})
        }
        /**
         * 创建订单
         */
        if (par === 3) {
            const urlParms = {
                'access_token': token,
                'gameUserId': userInfo.userGameId,
                'userQQ': '',
                'payBankId': payBankId,
                'payAmount': rechargePrice,
                'commodityId': chooseCommodityId,
                'payType': payType,
                'paySubType': chooseSubtype,
                'tradeType': tradeType,
                'mParam': 'phone',
            }
            rechargeCreate(urlParms, isH5).then(ret => {
                if (ret.code === '10000') {
                    const d = ret.data;
                    this.setState({
                        payOrderId: d.payOrderId,
                        paySource: d.paySource,
                        payName: d.payName,
                        vipDay: d.vipDay,
                        payVip: d.payVip,
                        currpage: par
                    })
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
                console.log(err)
            });
        }
        /**
         * 下单处理
         */
        if (par === 4) {
            if (payOrderId == null) {
                this.setState({
                    isShowTip: true,
                    showTipMsg: '请返回重新操作哦！'
                })
                return;
            }
            const urlParms = {
                'access_token': token,
                'payBankId': payBankId,
                'payAmount': rechargePrice,
                'payCommodityId': chooseCommodityId,
                'payItemName': '',
                'payOrderId': payOrderId,
                'payType': payType,
                'paySubType': chooseSubtype,
                'tradeType': tradeType,
            }
            rechargePay(urlParms, isH5).then(ret => {
                if (ret.code === '10000') {
                    console.log(ret)
                    const d = ret.data;
                    if (payType === 17) {
                        sessionStorage.setItem('alipayJump', d.orderResult);
                        window.location.href = "/aliPayJump?t=" + Math.random();
                    } else {
                        window.location.href = d.orderResult;
                    }
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
                console.log(err)
            });
        }
        this.setState({currpage: par})
    }
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null,
            isPicShow: false,
            picNum: 0,
        })
    }
    render() {
        const {isYesOne, isYesTwo, userInfo, rechargePrice, payType} = this.state;

        return (
            <IonPage>
                <meta name="viewport" content="width=750,target-densitydpi=device-dpi,user-scalable=no"/>
                <meta name="format-detection" content="telephone=no"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <meta name="apple-mobile-web-app-status-bar-style" content="black"/>
                <IonContent fullscreen>
                    <Helmet placeholder={""}>
                        <link rel="stylesheet" href="//m.91y.com/templets/default/20190813/css/91y_phone.css" type="text/css"/>
                        <link rel="stylesheet" href="//m.91y.com//templets/default/20190813/css/91y_public.css?v=2021012801" type="text/css"/>
                    </Helmet>
                    <div className="p-box">
                        {/*<!--充值第一步-->*/}
                        {this.state.currpage === 1 &&
                            <div id="first" className="topup-top-bg">
                                <div className="t-user">
                                    <div className="uhead">
                                        <span className="vip">普通会员</span>
                                        <img id="headimg"
                                             src={userInfo.headImg !== "" ? userInfo.headImg : require("../images/m91y/111.jpg")}
                                             style={{verticalAlign: "unset"}} alt=""/>
                                    </div>
                                    <div className="uname">
                                        <b className="name nickname">{userInfo.nickName}</b>
                                        <span className="id gameid">ID:{userInfo.userGameId}</span>
                                    </div>

                                    <div className="data">
                                        <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                               className="data-table">
                                            <tbody>
                                            <tr>
                                                <th>奖券</th>
                                                <th>金币</th>
                                                <th>保险箱</th>
                                            </tr>
                                            <tr>
                                                <td className="GoldEgg">{userInfo.goldEgg}</td>
                                                <td className="Score">{userInfo.score}</td>
                                                <td className="InsureScore">{userInfo.insureScore}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="t-recharge">
                                    <div className="r-account">
                                        <em className="r-title">充值账号：</em>
                                        <span className="r-cot">
                                            <p id="currinfo">
                                                <span
                                                    className="nickname_e">{userInfo.nickName}({userInfo.userGameId})</span>
                                            </p>
                                        </span>
                                    </div>
                                    <ul className="recharge-list" id="recharge-list">
                                        {this.state.itemList !== null && this.state.itemList.map((v, index) => {
                                            let vipInfo = typeof v.expandJson !== undefined ? v.expandJson : {
                                                vipName: '',
                                                vipDays: ''
                                            };
                                            return (
                                                <React.Fragment key={index}>
                                                    <li key={index}
                                                        className={this.state.chooseCommodityId === v.commodityPackGroupId ? 'on' : ''}
                                                        onClick={() => this.chooseItemBox(v.commodityPackGroupId, v.scene, v.price)}>
                                                        <a>
                                                            {typeof v.items !== undefined && v.items.map((item, k) => {
                                                                if (item.propId === 0) {
                                                                    return (
                                                                        <p className="jb" key={"item_"+k}>{item.itemCount}{item.itemName}</p>
                                                                    );
                                                                }
                                                            })
                                                            }
                                                            <p className="rmb">{(typeof v.scene !== undefined && v.scene === "10015" ? '会员' : '') + v.price}元</p>
                                                        </a>
                                                        <div className="recharge-tip"
                                                             style={this.state.chooseCommodityId === v.commodityPackGroupId ? {display: "block"} : {display: "none"}}>送{vipInfo.vipName}{vipInfo.vipDays}天
                                                        </div>
                                                    </li>
                                                </React.Fragment>
                                            )
                                        })}
                                    </ul>
                                    <a className="recharge-btn" onClick={e => this.jumpNext(2)}>下一步</a>
                                </div>
                            </div>
                        }
                        {/*<!--充值第一步end-->*/}
                        {/*<!--充值第二步-->*/}
                        {this.state.currpage === 2 &&
                            <div id="second">
                                <div className="t-recharge">
                                    <div className="r-account">
                                        <em className="r-title">充值账号：</em>
                                        <span className="r-cot">
                                        <p className="nickname_e">{userInfo.nickName}({userInfo.userGameId})</p>
                                    </span>
                                    </div>
                                    <div className="r-account">
                                        <em className="r-title">充值金额：</em>
                                        <span className="r-cot">
                                            <p id="rgrmb" className="r-amount">{rechargePrice}</p>
                                        </span>
                                    </div>
                                    <div className="r-account">
                                        <em className="r-title">充值方式：</em>
                                        <span className="r-cot">
                                        <ul className="r-choose-list" id="form">
                                            <li className={payType === 17 ? "on" : ""}
                                                onClick={e => this.setState({
                                                    payType: 17,
                                                    payBankId: 'alipay',
                                                    tradeType: 6,
                                                })}>支付宝</li>
                                            <li className={payType === 61 ? "on" : ""}
                                                onClick={e => this.setState({
                                                    payType: 61,
                                                    payBankId: 'wxh5',
                                                    tradeType: 4,
                                                })}>微信</li>
                                        </ul>
                                    </span>
                                    </div>
                                    <div className="agreement">
                                        <p>
                                            <em id="fwtk" className={isYesOne ? "" : "off"} onClick={e => this.setState({isYesOne: !isYesOne})}></em>
                                            我已阅读并同意
                                            <a href="https://m.91y.com/help/sjguize/2340.html">
                                                《关于充值的特别提示和约定》
                                            </a>
                                        </p>
                                        <p>
                                            <em id="xzd" className={isYesTwo ? "" : "off"} onClick={e => this.setState({isYesTwo: !isYesTwo})}></em>
                                            购买91游币时自动兑换为91y游戏中心道具
                                        </p>
                                    </div>
                                    <a className="recharge-btn" onClick={e => this.jumpNext(3)}>立即充值</a>
                                </div>
                            </div>
                        }
                        {/*<!--充值第二步end-->*/}
                        {/*<!--充值下单结果-->*/}
                        {this.state.currpage === 3 &&
                            <div id="result">
                                <div className="t-recharge">
                                    <div className="r-account">
                                        <em className="r-title">充值方式：</em>
                                        <span className="r-cot">
                                            <p id="formtext">{this.state.payType === 29 ? "微信" : "支付宝"}</p>
                                        </span>
                                    </div>
                                    <div className="r-account">
                                        <em className="r-title">订单号：</em>
                                        <span className="r-cot"><p id="ordertrade">{this.state.payOrderId}</p></span>
                                    </div>
                                    <div className="r-account">
                                        <em className="r-title">充值账号：</em>
                                        <span className="r-cot">
                                            <p id="payuser"
                                               className="nickname_e">{userInfo.nickName}({userInfo.userGameId})</p>
                                        </span>
                                    </div>
                                    <div className="r-account">
                                        <em className="r-title">充值金额：</em>
                                        <span className="r-cot">
                                            <p><b className="yellow" id="rmb">{this.state.rechargePrice}</b></p>
                                        </span>
                                    </div>
                                    <div className="r-account">
                                        <em className="r-title">金币数量：</em>
                                        <span className="r-cot">
                                            <p>获得<b className="yellow" id="souce">{this.state.paySource}</b>个金币，
                                                <span
                                                    id="viptext">{this.state.vipDay > 0 ? (this.state.payVip + this.state.vipDay + "天") : ""}</span>
                                            </p>
                                        </span>
                                    </div>
                                    <a className="recharge-btn" onClick={e => this.jumpNext(4)}>确认提交</a>
                                </div>
                            </div>
                        }
                        {/*<!--充值结果end-->*/}
                        {/*<!------------版权----------------->*/}
                        <MFooter title={"充值"} isJumpLogin={true}/>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(MPay);
